import { getLocationPartsTitles } from './getLocationPartsTitles'
import { Location } from '../../../types/models/Location.model'

const shouldRegionalizeTextForLocation = (location: Location): boolean => {
  const locationsPartTitles = getLocationPartsTitles(location)
  const notAsia = !locationsPartTitles.includes('Asia')
  const isIndia = locationsPartTitles.includes('India')
  const specificCountries = ['India', 'Canada', 'United Kingdom', 'Australia']
  return (
    isIndia ||
    (specificCountries.some((country) =>
      locationsPartTitles.includes(country)
    ) &&
      notAsia)
  )
}
export default shouldRegionalizeTextForLocation
